import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
export function approach(element: HTMLElement): void {
  gsap.registerPlugin(ScrollTrigger)

  const dots = element.querySelectorAll('.dot');

  const tl = gsap
    .timeline({
      scrollTrigger: {
        trigger: '.approach',
        scrub: true,

        start: 'top 100%',
        end: 'bottom 80%'
      }
    })

    .from('.line', {
      height: 0,
      ease: 'none'
    })

  ;[...dots].forEach((el) => {
    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        end: "top 50%",
        scrub: true
      },
      opacity: 1
    });
  })

  const players = element.querySelectorAll('lottie-player')
  
  if(players.length > 0) {
    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function handleScroll() {
      players.forEach( (player) => {
        player.pause()  
        if (isElementInViewport(player)) {
          player.play()
        }
      })
    }

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);
  }
}
